import { SPAN_KIND_LABEL, type Span } from '@/domain';
import { strings } from '@/shared/strings';
import styles from './SpanList.module.css';

/**
 * The bridges and bars of a case, one line each: the name on the left, the
 * kind and its two ends on the right. Renders nothing at all when the case
 * has none, heading included, rather than leaving a heading over an empty
 * list.
 */
export function SpanList({ spans, heading }: { spans: readonly Span[]; heading: string }) {
  if (spans.length === 0) return null;

  return (
    <div className={styles.list}>
      <h4 className={styles.heading}>{heading}</h4>
      <ul className={styles.rows}>
        {spans.map((span) => (
          <li key={span.id} className={styles.row}>
            <span className={styles.name}>{span.name}</span>
            <span className={styles.meta}>
              {SPAN_KIND_LABEL[span.kind]} · {span.from} {strings.odontogram.to} {span.to}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
